import * as React from 'react';
import { Component } from 'react';
import { Menu } from 'react-admin';
import PropTypes from 'prop-types';
import { useState } from "react";

//import { withRouter } from 'react-router-dom';
import {
    DashboardMenuItem,
    MenuItemLink,
} from 'react-admin';

import SubMenu from './SubMenu';

import orders from '../orders';
import approvals from '../approvals';
import payments from '../payments';
import templates from '../templates';
import templateCategories from '../template-categories';
import steps from '../steps';
import product_type from '../product_type';
import product_type_option from '../product_type_option';
import canvas_background_textures from '../canvas_background_textures';
import customCanvasPrices from '../custom-canvas-prices';
import notificationsTemplate from '../notification-templates';
import users from '../users';
import coupons from '../coupons';
import SystemIcon from '@mui/icons-material/Settings';

class Menu1 extends Component {
    state = {
        menuCatalog: false,
        menuSales: false,
        menuTemplates: false,
        menuCustomers: false,
        menuSystem: false,
    };

    static propTypes = {
        onMenuClick: PropTypes.func,
        logout: PropTypes.object,
    };

    handleToggle = menu => {
        this.setState(state => ({ [menu]: !state[menu] }));
    };

    render() {
        const { onMenuClick, open, logout } = this.props;

        return (
            <div>
                {' '}
                <DashboardMenuItem onClick={onMenuClick} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    open: state.admin.ui.sidebarOpen,
    theme: state.theme,
});

// const enhance = compose(
//     connect(
//         mapStateToProps,
//         {}
//     )
// );

export const MyMenu = () => {
    const [menuSales, setMenuSales] = useState(false);
    const [menuTemplates, setMenuTemplates] = useState(false);
    const [menuSystem, setMenuSystem] = useState(false);

    return <Menu>
            <Menu.DashboardItem />
            <SubMenu
                handleToggle={ () => setMenuSales(!menuSales) }
                isOpen={menuSales}
                sidebarIsOpen={open}
                name="Sales"
                icon={<orders.icon />}
            >
                <MenuItemLink
                    to={`/orders`}
                    primaryText="Orders"
                    leftIcon={<orders.icon />}
                    //onClick={onMenuClick}
                />
                {/* <MenuItemLink
                    to={`/canvases`}
                    primaryText="Canvases"
                    leftIcon={<canvases.icon />}
                    onClick={onMenuClick}
                /> */}
                {/* <MenuItemLink
                    to={`/images`}
                    primaryText="Images"
                    leftIcon={<images.icon />}
                    onClick={onMenuClick}
                /> */}
                {/* <MenuItemLink
                    to={`/texts`}
                    primaryText="Texts"
                    leftIcon={<texts.icon />}
                    onClick={onMenuClick}
                /> */}
                <MenuItemLink
                    to={`/approvals`}
                    primaryText="Approvals"
                    leftIcon={<approvals.icon />}
                    //onClick={onMenuClick}
                />
                <MenuItemLink
                    to={`/payments`}
                    primaryText="Payments"
                    leftIcon={<payments.icon />}
                    //onClick={onMenuClick}
                />
                {/* <MenuItemLink
                    to={`/address`}
                    primaryText="Addresses"
                    leftIcon={<addresses.icon />}
                    onClick={onMenuClick}
                /> */}
            </SubMenu>

            <SubMenu
                handleToggle={ () => setMenuTemplates(!menuTemplates) }
                isOpen={menuTemplates}
                sidebarIsOpen={open}
                name="Products"
                icon={<templates.icon />}
            >

                <MenuItemLink
                        to={`/custom-canvas-prices`}
                        primaryText="Photo Canvas Prices"
                        leftIcon={<customCanvasPrices.icon />}
                        //onClick={onMenuClick}
                />
                
                <MenuItemLink
                        to={`/templates-all`}
                        primaryText="Templates"
                        leftIcon={<templates.icon />}
                        //onClick={onMenuClick}
                />
                {/* <MenuItemLink
                        to={`/template-prices`}
                        primaryText="Template Pricings"
                        leftIcon={<templatePrices.icon />}
                        onClick={onMenuClick}
                /> */}
                <MenuItemLink
                        to={`/steps`}
                        primaryText="Template Steps"
                        leftIcon={<steps.icon />}
                        //onClick={onMenuClick}
                />
                <MenuItemLink
                        to={`/template-categories`}
                        primaryText="Categories"
                        leftIcon={<templateCategories.icon />}
                        //onClick={onMenuClick}
                />
                <MenuItemLink
                        to={`/product_type`}
                        primaryText="Product Types"
                        leftIcon={<product_type.icon />}
                        //onClick={onMenuClick}
                />
                <MenuItemLink
                        to={`/product_type_option`}
                        primaryText="Product Options"
                        leftIcon={<product_type_option.icon />}
                        //onClick={onMenuClick}
                />
                <MenuItemLink
                        to={`/canvas-background-textures`}
                        primaryText="Canvas Textures"
                        leftIcon={<canvas_background_textures.icon />}
                        //onClick={onMenuClick}
                />
        {/* 
                <MenuItemLink
                        to={`/materials`}
                        primaryText="Materials"
                        leftIcon={<materials.icon />}
                        onClick={onMenuClick}
                /> */}

            </SubMenu>

            <MenuItemLink
                    to={`/users`}
                    primaryText='Users'
                    leftIcon={<users.icon />}
                    //onClick={onMenuClick}
            />  

            <MenuItemLink
                    to={`/coupons`}
                    primaryText='Coupons'
                    leftIcon={<coupons.icon />}
                    //onClick={onMenuClick}
            />  

            <SubMenu
                handleToggle={() => setMenuSystem(!menuSystem)}
                isOpen={menuSystem}
                sidebarIsOpen={open}
                name="System"
                icon={<SystemIcon />}
            >
                <MenuItemLink
                    to={`/notification-templates`}
                    primaryText='Status Notifications'
                    leftIcon={<notificationsTemplate.icon />}
                //onClick={onMenuClick}
                />
            </SubMenu>
        </Menu>
};